module.exports = __webpack_public_path__ + "img/house5b.42be9a60.jpg";